Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = valueReducer;

var _constants = require('../constants');

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function valueReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _constants.SET_VALUE:
      return _extends({}, state, _defineProperty({}, action.component, {
        value: action.value,
        label: action.label || action.component,
        showFilter: action.showFilter,
        URLParams: action.URLParams,
        componentType: action.componentType,
        category: action.category
      }));

    case _constants.PATCH_VALUE:
      return _extends({}, state, _defineProperty({}, action.component, _extends({}, state[action.component], action.payload)));

    case _constants.CLEAR_VALUES:
      return {};

    case _constants.REMOVE_COMPONENT:
      {
        var del = state[action.component],
            obj = _objectWithoutProperties(state, [action.component]);

        return obj;
      }

    default:
      return state;
  }
}